import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyEventTypesQueryVariables = Types.Exact<{
  timezone: Types.Scalars['String'];
}>;


export type MyEventTypesQuery = { __typename?: 'Query', MyEventTypes: Array<{ __typename?: 'EventTypeEntity', id: string, userId: string, name: string, description?: string | null, color: string, duration: number, maxEvents?: number | null, minNotice?: number | null, beforeBuffer?: number | null, afterBuffer?: number | null, timezone?: string | null, active: boolean, EventTypeAvailability?: Array<{ __typename?: 'EventTypeAvailabilityEntity', id: string, day: string, EventTypeAvailabilityBracket?: Array<{ __typename?: 'EventTypeAvailabilityBracketEntity', id: string, startHour: number, startMinute: number, endHour: number, endMinute: number }> | null }> | null }> };

export type MyEventsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyEventsQuery = { __typename?: 'Query', MyEvents: Array<{ __typename?: 'EventEntity', id: string, eventTypeId: string, organizerId: string, meetingId: string, status: Types.EventStatuses, startDate: any, endDate: any, title: string, notes?: string | null, type: Types.EventType, createAt: any, Meetings: { __typename?: 'MeetingEntity', id: string, channelId: string, MeetingAttendees: Array<{ __typename?: 'MeetingAttendeesEntity', id: string, userId?: string | null, unregisteredUserId?: string | null, firstName?: string | null, lastName?: string | null }> }, EventTypes: { __typename?: 'EventTypeEntity', id: string, userId: string, name: string, description?: string | null, color: string, duration: number, maxEvents?: number | null, minNotice?: number | null, beforeBuffer?: number | null, afterBuffer?: number | null, timezone?: string | null, active: boolean } }> };

export type GetCalendarOauthUrlQueryVariables = Types.Exact<{
  provider: Types.Scalars['String'];
}>;


export type GetCalendarOauthUrlQuery = { __typename?: 'Query', getCalendarOauthUrl: string };

export type GetExternalCalendarEventsQueryVariables = Types.Exact<{
  filters: Types.ExternalCalendarFilterDto;
}>;


export type GetExternalCalendarEventsQuery = { __typename?: 'Query', getExternalEvents: Array<{ __typename?: 'MappedExternalEventEntity', id: string, organizerId: string, status: Types.EventStatuses, startDate: any, endDate: any, title: string, notes: string, type: Types.EventType, color: string, duration: number, iCalUID: string, attendees: Array<{ __typename?: 'MappedExternalEventAttendees', name?: string | null, email?: string | null, status?: string | null }> }> };


export const MyEventTypesDocument = gql`
    query MyEventTypes($timezone: String!) {
  MyEventTypes(timezone: $timezone) {
    id
    userId
    name
    description
    color
    duration
    maxEvents
    minNotice
    beforeBuffer
    afterBuffer
    timezone
    active
    EventTypeAvailability {
      id
      day
      EventTypeAvailabilityBracket {
        id
        startHour
        startMinute
        endHour
        endMinute
      }
    }
  }
}
    `;

/**
 * __useMyEventTypesQuery__
 *
 * To run a query within a React component, call `useMyEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventTypesQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useMyEventTypesQuery(baseOptions: Apollo.QueryHookOptions<MyEventTypesQuery, MyEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEventTypesQuery, MyEventTypesQueryVariables>(MyEventTypesDocument, options);
      }
export function useMyEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEventTypesQuery, MyEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEventTypesQuery, MyEventTypesQueryVariables>(MyEventTypesDocument, options);
        }
export type MyEventTypesQueryHookResult = ReturnType<typeof useMyEventTypesQuery>;
export type MyEventTypesLazyQueryHookResult = ReturnType<typeof useMyEventTypesLazyQuery>;
export type MyEventTypesQueryResult = Apollo.QueryResult<MyEventTypesQuery, MyEventTypesQueryVariables>;
export const MyEventsDocument = gql`
    query MyEvents {
  MyEvents {
    id
    eventTypeId
    organizerId
    meetingId
    status
    startDate
    endDate
    title
    notes
    type
    createAt
    Meetings {
      id
      channelId
      MeetingAttendees {
        id
        userId
        unregisteredUserId
        firstName
        lastName
      }
    }
    EventTypes {
      id
      userId
      name
      description
      color
      duration
      maxEvents
      minNotice
      beforeBuffer
      afterBuffer
      timezone
      active
    }
  }
}
    `;

/**
 * __useMyEventsQuery__
 *
 * To run a query within a React component, call `useMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
      }
export function useMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
        }
export type MyEventsQueryHookResult = ReturnType<typeof useMyEventsQuery>;
export type MyEventsLazyQueryHookResult = ReturnType<typeof useMyEventsLazyQuery>;
export type MyEventsQueryResult = Apollo.QueryResult<MyEventsQuery, MyEventsQueryVariables>;
export const GetCalendarOauthUrlDocument = gql`
    query getCalendarOauthUrl($provider: String!) {
  getCalendarOauthUrl(provider: $provider)
}
    `;

/**
 * __useGetCalendarOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetCalendarOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarOauthUrlQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetCalendarOauthUrlQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarOauthUrlQuery, GetCalendarOauthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarOauthUrlQuery, GetCalendarOauthUrlQueryVariables>(GetCalendarOauthUrlDocument, options);
      }
export function useGetCalendarOauthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarOauthUrlQuery, GetCalendarOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarOauthUrlQuery, GetCalendarOauthUrlQueryVariables>(GetCalendarOauthUrlDocument, options);
        }
export type GetCalendarOauthUrlQueryHookResult = ReturnType<typeof useGetCalendarOauthUrlQuery>;
export type GetCalendarOauthUrlLazyQueryHookResult = ReturnType<typeof useGetCalendarOauthUrlLazyQuery>;
export type GetCalendarOauthUrlQueryResult = Apollo.QueryResult<GetCalendarOauthUrlQuery, GetCalendarOauthUrlQueryVariables>;
export const GetExternalCalendarEventsDocument = gql`
    query getExternalCalendarEvents($filters: ExternalCalendarFilterDto!) {
  getExternalEvents(filters: $filters) {
    id
    organizerId
    status
    startDate
    endDate
    title
    notes
    type
    color
    duration
    iCalUID
    attendees {
      name
      email
      status
    }
  }
}
    `;

/**
 * __useGetExternalCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetExternalCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalCalendarEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetExternalCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalCalendarEventsQuery, GetExternalCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalCalendarEventsQuery, GetExternalCalendarEventsQueryVariables>(GetExternalCalendarEventsDocument, options);
      }
export function useGetExternalCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalCalendarEventsQuery, GetExternalCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalCalendarEventsQuery, GetExternalCalendarEventsQueryVariables>(GetExternalCalendarEventsDocument, options);
        }
export type GetExternalCalendarEventsQueryHookResult = ReturnType<typeof useGetExternalCalendarEventsQuery>;
export type GetExternalCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetExternalCalendarEventsLazyQuery>;
export type GetExternalCalendarEventsQueryResult = Apollo.QueryResult<GetExternalCalendarEventsQuery, GetExternalCalendarEventsQueryVariables>;
export const namedOperations = {
  Query: {
    MyEventTypes: 'MyEventTypes',
    MyEvents: 'MyEvents',
    getCalendarOauthUrl: 'getCalendarOauthUrl',
    getExternalCalendarEvents: 'getExternalCalendarEvents'
  }
}